import { useNavigate } from 'react-router-dom';
import { Producto } from '../../services/productoService';

interface ProductCardProps {
  producto: Producto;
}

const ProductCard = ({ producto }: ProductCardProps) => {
  const navigate = useNavigate();
  const precio = typeof producto.precioBase === 'string' 
    ? parseFloat(producto.precioBase) 
    : (producto.precioBase || 0);

  return (
    <div
      onClick={() => navigate(`/tienda/productos/${producto.id}`)}
      className="bg-white rounded-lg shadow-md hover:shadow-xl transition-all duration-300 cursor-pointer overflow-hidden group"
    >
      {/* Imagen del producto */}
      <div className="relative overflow-hidden bg-gray-100 aspect-square">
        {producto.imagenUrl ? (
          <img
            src={producto.imagenUrl}
            alt={producto.name}
            className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300"
            onError={(e) => {
              (e.target as HTMLImageElement).src = 'https://via.placeholder.com/400x400?text=Sin+Imagen';
            }}
          />
        ) : (
          <div className="w-full h-full flex items-center justify-center bg-gradient-to-br from-gray-200 to-gray-300">
            <svg
              className="w-24 h-24 text-gray-400"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
              />
            </svg>
          </div>
        )}
        {/* Badge de categoría */}
        {producto.categoria && (
          <div className="absolute top-2 left-2 bg-primary-600 text-white px-2 py-1 rounded-full text-xs font-medium">
            {producto.categoria.name}
          </div>
        )}
        {/* Badge de tipo */}
        {producto.tipo !== 'producto' && (
          <div className="absolute top-2 right-2 bg-green-500 text-white px-2 py-1 rounded-full text-xs font-medium">
            {producto.tipo === 'servicio' ? 'Servicio' : 'Combo'}
          </div>
        )}
      </div>

      {/* Información del producto */}
      <div className="p-4">
        <h3 className="font-semibold text-gray-900 mb-1 line-clamp-2 group-hover:text-primary-600 transition-colors">
          {producto.name}
        </h3>
        {producto.description && (
          <p className="text-sm text-gray-500 mb-2 line-clamp-2">
            {producto.description}
          </p>
        )}
        <div className="flex items-center justify-between mt-3">
          <div>
            <p className="text-2xl font-bold text-gray-900">
              ${precio.toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
            </p>
            {producto.unidadMedida && producto.unidadMedida !== 'unidad' && (
              <p className="text-xs text-gray-500">por {producto.unidadMedida}</p>
            )}
          </div>
          <button
            onClick={(e) => {
              e.stopPropagation();
              // TODO: Agregar al carrito
            }}
            className="bg-primary-600 text-white px-4 py-2 rounded-lg hover:bg-primary-700 transition-colors font-medium"
          >
            Agregar
          </button>
        </div>
      </div>
    </div>
  );
};

export default ProductCard;

